import { Link } from "react-router-dom";

export default function Footer() {
  const quickLinks = [
    { label: "Home", href: "/" },
    { label: "Services", href: "/#services" },
    { label: "Publications", href: "/publications" },
    { label: "Team", href: "/#team" },
    { label: "Contact", href: "/#contact" },
    { label: "Dialer", href: "https://dialer.lionpridefinancial.com" },
    { label: "Leads", href: "https://leads.lionpridefinancial.com" },
    { label: "SEC Filing Intelligence", href: "https://sec.lionpridefinancial.com" },
  ];

  return (
    <footer className="border-t border-white/10 bg-slate-950 px-6 py-10 text-slate-400">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-3">
        <div>
          <h4 className="mb-3 font-semibold text-white">Lion Pride Financial</h4>
          <p>31 Napa Valley Rd<br />Gaithersburg, MD 20878</p>
          <p className="mt-3">
            📞 <a href="tel:+12403403843" className="text-cyan-200 hover:underline">(240) 340-3843</a>
          </p>
        </div>

        <div>
          <h4 className="mb-3 font-semibold text-white">Quick Links</h4>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
            {quickLinks.map(({ label, href }) => (
              <li key={label}>
                <a
                  href={href}
                  className="hover:text-cyan-200 hover:underline"
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-semibold text-white">Connect</h4>
          <p>Educational planning content, consultations, and financial strategy conversations.</p>
        </div>
      </div>

      <div className="mt-10 text-center text-sm">
        <span>© {new Date().getFullYear()} Lion Pride Financial. All rights reserved.</span>
        <span className="mx-3">•</span>
        <Link to="/terms" className="hover:text-cyan-200 hover:underline">Terms of Service</Link>
        <span className="mx-3">•</span>
        <Link to="/privacy" className="hover:text-cyan-200 hover:underline">Privacy Policy</Link>
      </div>
    </footer>
  );
}
